import { render, staticRenderFns } from "./GradeCreate.vue?vue&type=template&id=dbfe3f70"
import script from "@/controllers/custom/grade/grade-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/grade/grade-create.js?vue&type=script&lang=js&external"
import style0 from "./GradeCreate.vue?vue&type=style&index=0&id=dbfe3f70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports